import React from "react";
import styles from "./About.module.scss";

// Components
import Intro from "./components/Intro";
import WhatIsIEEEKSB from "./components/WhatIsIEEEKSB";
import NeedHelp from "./components/NeedHelp";
import WhatIsIEEE from "./components/WhatIsIEEE";
import Footer from "components/Shared/Footer";


const About = () => {
  return (
    <div className={styles.About}>
      <Intro />
      <WhatIsIEEE />
      <WhatIsIEEEKSB />
      <NeedHelp />
      <Footer />
    </div>
  );
};

export default About;
